import Tooltip from 'rc-tooltip'

import 'rc-tooltip/assets/bootstrap.css'
import './WithTooltip.css'

export const WithTooltip = function ({
  overlay,
  overlayClassName = '',
  border,
  children,
  id,
  placement = 'top',
  type = 'dark',
  className = ''
}) {
  if (!overlay) {
    return <>{children}</>
  }

  const themeStyles =
    type === 'dark'
      ? { background: 'rgba(41, 45, 63, 0.9)', color: 'white' }
      : type === 'light'
      ? { background: 'white', color: 'black' }
      : {}

  // Defined in WithTooltip.css
  const themeCss = `theme-${type}`

  let overlayInnerStyle = {
    backdropFilter: 'blur(2.5px)',
    borderRadius: '0.5rem',
    padding: '0.8333rem',
    ...themeStyles
  }

  if (border) {
    overlayInnerStyle.border = '1px solid #DBDBE3'
  }

  return (
    <Tooltip
      align={{
        overflow: { adjustX: true, adjustY: true, alwaysByViewport: true }
      }}
      destroyTooltipOnHide
      id={id}
      overlay={overlay}
      overlayClassName={`no-opacity mx-auto w-fit ${themeCss} ${overlayClassName}`}
      overlayInnerStyle={overlayInnerStyle}
      placement={placement}
    >
      <span className={className}>{children}</span>
    </Tooltip>
  )
}
